import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getColor } from "utils/colors";

const getRows = (data) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        tipo: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.tipo}
            </SoftTypography>
          </SoftBox>
        ),
        descripcion: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.descripcion}
            </SoftTypography>
          </SoftBox>
        ),
        observacion: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.observacion || "Sin observación"}
            </SoftTypography>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "descripcion", desc: "Descripción", align: "left", noOrder: true, width: "1%" },
  { name: "tipo", desc: "Tipo", align: "center", noOrder: true },
  { name: "observacion", desc: "Observación", align: "left", noOrder: true },
];

export default { columns, getRows };
